import PageLayout from "@/components/PageLayout";
import { Button } from "@/components/ui/button";
import { ArrowRight, Check } from "@/components/Icon";
import { Link } from "react-router-dom";
import samplesClothing from "@/assets/samples-clothing.webp";
import dtfPrinting from "@/assets/technique-dtf.webp";

const IMG = "/images";

const products = [
  {
    sectionTitle: "10 stuks pakket aanbiedingen! Stel zelf uw pakket van 10 stuks samen!",
    priceTitle: "Prijzen t-shirts",
    priceLine: "Inclusief 1 bedrukking A4 formaat",
    price: "12,50",
    intro:
      "Bij minimale afname van 10 stuks. Stel zelf uw pakket samen met evt. polo's, sweaters en hoodies die op deze aanbiedingen pagina staan.",
    image: `${IMG}/t-shirt-actie.webp`,
    colors: `${IMG}/kleuren-t-shirts.webp`,
    features: [
      "185 g/m²",
      "100% katoen, voorgekrompen en ringgesponnen",
      "Ash: 99% katoen, 1% viscose · Sport Grey: 85% katoen, 15% viscose",
      "Dunne geribde kraag met ronde hals",
      "Nektape",
      "Rondgebreid",
      "Wasbaar tot 40°C",
      "Normale pasvorm",
    ],
  },
  {
    sectionTitle: "Polo pakket",
    priceTitle: "Prijzen polo's",
    priceLine: "Inclusief bedrukking A4 formaat",
    price: "14,50",
    intro:
      "Bij minimale afname van 10 stuks. Stel zelf uw pakket samen met evt. t-shirts, sweaters en hoodies die op deze aanbiedingen pagina staan.",
    image: `${IMG}/polo-aanbieding.webp`,
    colors: `${IMG}/polo-kleuren.webp`,
    features: [
      "180 g/m²",
      "100% katoen (Optimium™), voorgekrompen en ringgesponnen (fijn piqué)",
      "Sport Grey: 90% katoen, 10% viscose · Meta Gold: 78% katoen, 15% polyester, 7% metallic",
      "Voelt zacht aan",
      "Nekband van schouder tot schouder",
      "Ribgebreide kraag en mouwboorden",
      "Knoopsluiting met 2 gelijkgekleurde knopen",
      "Gelijkmatig oppervlak voor heldere en scherpe drukresultaten",
      "Zijnaden",
    ],
  },
  {
    sectionTitle: "Sweater pakket",
    priceTitle: "Prijzen sweaters",
    priceLine: "Incl. 1 bedrukking in A4 formaat",
    price: "15,00",
    intro:
      "Bij minimale afname van 10 stuks. Stel zelf uw pakket samen met evt. t-shirts, polo's en hoodies die op deze aanbiedingen pagina staan.",
    image: `${IMG}/crew-aanbieding.webp`,
    colors: `${IMG}/sweater-kleuren.webp`,
    features: [
      "280 g/m²",
      "50% katoen (Better Cotton), 50% polyester (gerecycled) – RCS-gecertificeerd",
      "Echte genderneutrale stijl met zijnaden",
      "Klassieke moderne relaxte pasvorm voor alle gelegenheden",
      "Uitstekende bedrukbaarheid en handgevoel",
      "Ingezette mouwen met een licht verlaagde schouder zorgen voor meer bewegingsvrijheid",
      "Klassieke manchetten en onderzoom in 1×1 rib met elastaan",
      "B&C No Label oplossing",
    ],
  },
  {
    sectionTitle: "Hoodie pakket",
    priceTitle: "Prijzen hoodies",
    priceLine: "Incl. 1 bedrukking A4 formaat",
    price: "18,50",
    intro:
      "Bij minimale afname van 10 stuks. Stel zelf uw pakket samen met evt. t-shirts, polo's en sweaters die op deze aanbiedingen pagina staan.",
    image: `${IMG}/hoodie-aanbieding.webp`,
    colors: null,
    features: [
      "280 g/m²",
      "50% katoen (Better Cotton), 50% polyester (gerecycled) – RCS-gecertificeerd",
      "Echte genderneutrale stijl met zijnaden",
      "Klassieke moderne relaxte pasvorm voor alle gelegenheden",
      "Uitstekende bedrukbaarheid en handgevoel",
      "Vakkundig ontworpen capuchon met enkele jersey voering voor een perfecte pasvorm",
      "B&C No Label oplossing – gemakkelijk te decoreren",
    ],
  },
];

const Aanbiedingen = () => (
  <PageLayout
    title="Aanbiedingen"
    metaDescription="Aanbiedingen bij Magic Print: T-shirts vanaf €12,50, polo's vanaf €14,50, sweaters vanaf €15,00 en hoodies vanaf €18,50 inclusief bedrukking. Minimaal 10 stuks."
    ogImage={samplesClothing}
  >
    <h1 className="text-3xl md:text-5xl font-bold text-center mb-10 text-[#0a2933]">Aanbiedingen</h1>
    <div id="aanbiedingen" className="space-y-20 mb-20">

      {products.map((product, idx) => (
        <section key={product.priceTitle}>
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-10 text-[#0a2933]">
            {idx === 0 ? (
              <>
                10 stuks pakket aanbiedingen!
                <br />
                <span className="text-xl md:text-2xl font-bold">
                  Stel zelf uw pakket van 10 stuks samen!
                </span>
              </>
            ) : (
              product.sectionTitle
            )}
          </h2>

          <div className="grid md:grid-cols-2 gap-8 lg:gap-12 items-center">
            <div className="rounded-2xl overflow-hidden bg-muted/30">
              <img
                src={product.image}
                alt={`${product.priceTitle} — Magic Print`}
                loading="lazy"
                className="w-full h-auto object-cover"
              />
            </div>
            <div>
              <h3 className="text-2xl font-bold mb-4 text-[#0a2933]">
                {product.priceTitle}
              </h3>
              <p className="text-base mb-4">
                {product.priceLine}{" "}
                <span className="text-primary font-bold text-lg">€{product.price}</span>
              </p>
              <p className="italic text-muted-foreground mb-4">{product.intro}</p>
              <p className="mb-6">
                <strong>Bedrukking:</strong> full color, professioneel en uitstekend wasbaar.
              </p>
              <Button asChild size="lg">
                <Link to="/offerte-aanvragen">
                  Gratis offerte aanvragen <ArrowRight className="ml-2 w-4 h-4" />
                </Link>
              </Button>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-8 lg:gap-12 mt-10 items-center">
            <div>
              <p className="font-bold mb-4 text-[#0a2933]">Kenmerken:</p>
              <ul className="space-y-2">
                {product.features.map((f) => (
                  <li
                    key={f}
                    className="flex items-start gap-2 text-muted-foreground"
                  >
                    <Check className="w-4 h-4 text-primary mt-1.5 shrink-0" />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="font-bold mb-4 text-[#0a2933]">Kleuren</p>
              {product.colors ? (
                <img
                  src={product.colors}
                  alt={`Beschikbare kleuren ${product.priceTitle}`}
                  loading="lazy"
                  className="w-full max-w-sm h-auto"
                />
              ) : (
                <p className="max-w-sm rounded-xl border border-border bg-muted/30 p-5 text-muted-foreground">
                  Diverse kleuren beschikbaar. Vraag naar de actuele kleuren bij uw offerteaanvraag.
                </p>
              )}
            </div>
          </div>
        </section>
      ))}
    </div>

    <section className="mb-16 grid md:grid-cols-2 gap-8 lg:gap-12 items-center">
      <div>
        <h2 className="text-2xl md:text-3xl font-bold mb-4 text-[#0a2933]">
          Op zoek naar kwalitatieve team- of promokleding tegen de beste prijs?
        </h2>
        <p className="text-muted-foreground mb-6">
          Profiteer nu van onze speciale actie: 10 stuks T-shirts, polo's, sweaters of hoodies tegen de laagste prijs.
        </p>
        <ul className="space-y-3 mb-8">
          <li className="flex items-center gap-3">
            <Check className="w-5 h-5 text-primary shrink-0" /> Perfect voor bedrijven, verenigingen en evenementen
          </li>
          <li className="flex items-center gap-3">
            <Check className="w-5 h-5 text-primary shrink-0" /> Kies zelf je kleuren
          </li>
          <li className="flex items-center gap-3">
            <Check className="w-5 h-5 text-primary shrink-0" /> Altijd gegarandeerde topkwaliteit
          </li>
        </ul>
        <Button asChild size="lg">
          <a href="#aanbiedingen">
            Bekijk de aanbiedingen <ArrowRight className="ml-2 w-4 h-4" />
          </a>
        </Button>
      </div>
      <img
        src={samplesClothing}
        alt="Magic Print 10 stuks actie"
        loading="lazy"
        className="w-full h-auto rounded-2xl"
      />
    </section>

    <section className="mb-16 grid md:grid-cols-2 gap-8 lg:gap-12 items-center">
      <img
        src={`${IMG}/b-and-c-group-photo.webp`}
        alt="B&C kleding bedrukken bij Magic Print"
        loading="lazy"
        className="w-full h-auto rounded-2xl"
      />
      <div>
        <h2 className="text-2xl md:text-3xl font-bold mb-4 text-[#0a2933]">
          B&C T-shirts, polo's, sweaters en hoodies bedrukken bij Magic Print
        </h2>
        <p className="text-muted-foreground mb-4">
          Ontdek de hoogwaardige kwaliteit van B&C kleding bij Magic Print. Wij kiezen bewust voor B&C T-shirts, polo's, sweaters en hoodies vanwege hun uitstekende pasvorm, duurzaamheid en comfortabele draagervaring. Deze kledingstukken blijven mooi in model, voelen zacht aan en zijn perfect geschikt voor bedrukking of borduring.
        </p>
        <p className="text-muted-foreground mb-4">
          Bij Magic Print zorgen wij ervoor dat jouw logo, ontwerp of boodschap haarscherp tot zijn recht komt op de beste materialen. Of je nu gaat voor een klassiek T-shirt, een representatieve polo of een trendy hoodie – B&C combineert kwaliteit met een moderne uitstraling. Ideaal voor bedrijfskleding, promotionele events of gewoon in je vrije tijd.
        </p>
        <p className="text-muted-foreground">
          Kies voor B&C bij Magic Print en maak altijd een professionele indruk.
        </p>
      </div>
    </section>

    <section className="mb-12 grid md:grid-cols-2 gap-8 lg:gap-12 items-center">
      <div>
        <h2 className="text-2xl md:text-3xl font-bold mb-4 text-[#0a2933]">
          Alles bedrukt met DTF!
        </h2>
        <p className="text-muted-foreground mb-4">
          Met DTF (Direct To Film) komen jouw ontwerpen echt tot leven. Deze techniek zorgt voor heldere, levendige kleuren en een uitstekende wasbaarheid – zelfs na veelvuldig wassen blijft je print als nieuw.
        </p>
        <p className="text-muted-foreground">
          Het mooiste? Alle soorten afbeeldingen kunnen bedrukt worden: van fijne details en foto's tot opvallende logo's en kleurrijke designs. DTF is geschikt voor bijna ieder textiel en voelt bovendien soepel en comfortabel aan.
        </p>
      </div>
      <img
        src={dtfPrinting}
        alt="DTF print voorbeeld"
        loading="lazy"
        className="w-full h-auto rounded-2xl"
      />
    </section>
  </PageLayout>
);

export default Aanbiedingen;
